const host = window.location.host;
const devEnv = ['localhost', '-dev.'];

const SITE_ID = devEnv.some(env => host.includes(env)) ? '5de14b7f14920d065eda' : 'b67b80a028ab44e746f7';

var _cio = _cio || [];
(function() {
    var a,b,c;
    a=function(f) {
        return function() {
            _cio.push([f].concat(Array.prototype.slice.call(arguments,0)))
        }
    };
    b=["load","identify","sidentify","track","page"];
    for(c = 0; c < b.length; c++) {
        _cio[b[c]]=a(b[c])
    };
    var t = document.createElement('script'),
        s = document.getElementsByTagName('script')[0];
    t.async = true;
    t.id    = 'cio-tracker';
    t.setAttribute('data-site-id', SITE_ID);
    t.setAttribute('data-use-array-params', 'true');
    t.src = 'https://assets.customer.io/assets/track.js';
    //If your account is in the EU, use:
    //t.src = 'https://assets.customer.io/assets/track-eu.js'
    s.parentNode.insertBefore(t, s);
})();